import { forwardRef } from "react";

import classNames from "shared/utils/classNames";

type Props = {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  type?: string;
  isIframe?: boolean;
};

const TextInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    value,
    onChange,
    placeholder,
    maxLength,
    type = "text",
    isIframe,
    ...rest
  } = props;

  return (
    <input
      ref={ref}
      type={type}
      maxLength={maxLength}
      className={classNames(
        "w-full resize-none appearance-none rounded-lg border border-solid border-grey-1 p-2.5 pr-35 outline-none",
        isIframe
          ? "text-base placeholder:text-base"
          : "text-sm placeholder:text-sm ",
      )}
      placeholder={placeholder || ""}
      onChange={evt => onChange(evt.target.value)}
      value={value}
      {...rest}
    />
  );
});

TextInput.displayName = "TextInput";

export default TextInput;
